<script setup>

import InnerProofreadingSection from "@/views/preview/sections/InnerProofreadingSection.vue";
import { useWebsiteStore } from "@/stores/website";
import { useActiveDeviceRenderStore } from "@/stores/activeDeviceRender";
import PreviewScanError from "@/views/preview/PreviewScanError.vue";

const websiteStore = useWebsiteStore();
const activeDeviceRender = useActiveDeviceRenderStore();
const props = defineProps({
  devicePreview: Object,
  feedbackCategory: {
    type: String,
    default: "proofread",
  },
});
const integrityCategories = [
  'proofread.content_errors.visible_error_message',
  'proofread.content_errors.placeholder_text',
  'proofread.content_errors.unreplaced_variable',
  'proofread.content_errors.missing_referenced_element',
  'proofread.content_errors.image_text_conflict',
  'proofread.content_errors.spam_content',
  'proofread.logic.contradictory_facts',
  'proofread.logic.numerical_inconsistency',
  'proofread.logic.heading_content_mismatch',
  'proofread.visual.image_text_conflict',
  'proofread.visual.broken_image',
  'proofread.visual.low_contrast',
  'proofread.text_quality.spelling',
  'proofread.text_quality.grammar',
  'proofread.text_quality.readability',
  'proofread.text_quality.tone',
  'proofread.text_quality.capitalization',
]

</script>

<template>
  <preview-scan-error
      v-if="activeDeviceRender.page.status === 'completed' && activeDeviceRender.page.proofreadingState === 'error'"/>

    <div class="audit-summary">
    <inner-proofreading-section :devicePreview="devicePreview" :title="'Content Integrity '" :icon="`fa fa-magnifying-glass-chart`"
                                :categories=integrityCategories></inner-proofreading-section>
    </div>
</template>

<style>
/* Styles consolidated to src/assets/scss/custom/_preview-sections.scss */
</style>